import dburl from '../utils/dburl';

export default function fetchViewsForPage(name, method) {
  const url = `${dburl}View?name=${name}`;

  const options = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
    }
  }

  return fetch(url, options)
  .then(res => res.json())
  .catch(err => {
    console.log(err)
    return {status:404}
  })
}